import React from 'react';
import { Container, makeStyles, Grid } from '@material-ui/core';
import { useParams } from 'react-router-dom';

import {
  BackNavAdmin,
  ExternalContentForm
} from '../../components';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: theme.spacing(3),
  },
  card: {
    marginBottom: 20,
  },
}));

function ExternalContentsForm() {
  const classes = useStyles();
  const { id } = useParams();
  const { t } = useTranslation();

  return (
    <div>
      <BackNavAdmin title={!!id ? t('conteudos') : t('conteudos')}></BackNavAdmin>
      <Container maxWidth="lg" className={classes.root}>
        <Grid container spacing={3}>
          <Grid item sm={9} xs={12}>
            <div className={classes.card}>
              <ExternalContentForm 
                contentId={id}
              />
            </div>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}

export { ExternalContentsForm };
